/* unplugin-vue-components disabled */import script from "./EarTraining808.vue?vue&type=script&setup=true&lang=js"
export * from "./EarTraining808.vue?vue&type=script&setup=true&lang=js"

import "./EarTraining808.vue?vue&type=style&index=0&id=35b059ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35b059ce"]])

export default __exports__